const initialState = {
  loading: false,
  error: false,
  message: "",
  rawData: [],
  data: {},
  dataChart: {
    new: { loading: false, data: null },
    semi: { loading: false, data: null },
    os: { loading: false, data: null },
    hos: { loading: false, data: null },
    service: { loading: false, data: null },
    expenses: { loading: false, data: null },
  },
  select: {},
  year: 0,
  month: 0,
  type: 0,
  typeData: 0,
  vsMorD: 0,
  selectStatusChart: JSON.parse(
    localStorage.getItem("selectStatusChartV2")
  ) || {
    new: { idIndicator: null, group: 0, vs: 1, idBrand: [], year: null },
    semi: { idIndicator: null, group: 0, vs: 1, idBrand: [], year: null },
    service: { idIndicator: null, group: 0, vs: 1, idBrand: [], year: null },
    os: { idIndicator: null, group: 0, vs: 1, idBrand: [], year: null },
    hos: { idBrand: [], year: null },
    expenses: { idIndicator: null, group: 0, vs: 1, idBrand: [], year: null },
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "LOADING_DEALER_PROFILE":
      return { ...state, error: false, loading: action.payload };
    case "READY_DATA_DEALER_PROFILE":
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
        rawData: action.payload.rawData,
      };
    case "READY_SELECT_DEALER_PROFILE":
      return { ...state, loading: false, error: false, select: action.payload };
    case "LOADING_CHART_DEALER_PROFILE":
      return {
        ...state,
        dataChart: {
          ...state.dataChart,
          [action.payload.type]: {
            ...state.dataChart[action.payload.type],
            data: null,
            loading: action.payload.loading,
          },
        },
      };
    case "READY_DATA_CHART_DEALER_PROFILE":
      return {
        ...state,
        dataChart: {
          ...state.dataChart,
          [action.payload.type]: {
            ...state.dataChart[action.payload.type],
            data: action.payload.data,
            loading: false,
          },
        },
      };
    case "CHANGE_SELECT_CHART_DEALER_PROFILE":
      return {
        ...state,
        selectStatusChart: {
          ...state.selectStatusChart,
          [action.payload.type]: {
            ...state.selectStatusChart[action.payload.type],
            [action.payload.select]: action.payload.value,
          },
        },
      };
    case "CHANGE_TYPE_DEALER_PROFILE":
      return {
        ...state,
        loading: false,
        error: false,
        type: action.payload.type,
        vsMorD: action.payload.vsMorD,
        data: action.payload.data,
      };
    case "CHANGE_TYPE_DATA_DEALER_PROFILE":
      return {
        ...state,
        loading: false,
        error: false,
        typeData: action.payload,
      };
    case "ERROR_DEALER_PROFILE":
      return { ...state, loading: false, error: true, message: action.payload };
    case "CHANGE_DATE_DEALER_PROFILE":
      return {
        ...state,
        year: action.payload.year,
        month: action.payload.month,
        data: {},
        rawData: [],
        type: 0,
        vsMorD: 0,
      };
    default:
  }
  return state;
};
